























































































































































































































import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'

// usecases
import FetchCartQueryStatusUseCase from '@/usecases/event/FetchCartQueryStatusUseCase'
import DeleteCartQueryUseCase from '@/usecases/c4/DeleteCartQueryUseCase'
import SearchEventCartQueryPhotosUseCase from '@/usecases/event/SearchEventCartQueryPhotosUseCase'

// Containers
import UnlockPasswordContainer from '@/containers/Event/UnlockPassword'
import SearchPhotosContainer from '@/containers/Event/SearchPhotos'
import UchinokoSelectContainer from '@/containers/Event/UchinokoSelect'
import RecommendEvents from '@/containers/Event/RecommendEvents'
import DlSetDescription from '@/containers/Event/DlSetDescription'

// Components
import UchinokoButton from '@/components/Event/Uchinoko/Button'
import SectionHeader from '@/components/shared/atoms/ContentParts/SectionHeader'
import EventAlbumList from '@/components/Event/Album/List'
import EventTitle from '@/components/Event/Title'
import LeadText from '@/components/Event/LeadText'
import RemainingInfo from '@/components/Event/RemainingInfo'
import Button from '@/components/shared/atoms/Button/Button'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import TextLink from '@/components/shared/atoms/TextLink'
import CategoryText from '@/components/Event/Title/CategoryText'
import Modal from '@/components/shared/atoms/Modal'
import ClearButton from '@/components/shared/atoms/Button/CloseButton'
import SingleIcon from '@/components/Event/Uchinoko/SingleIcon'

// dataStream
import { setRecord } from '@/plugins/dataStream'
import { AlbumListSchema, EventDetailSchema, FaceDetectClearClickSchema } from '@/types/dataStream'

// userAgent
import { userAgentDedicatedToDataStream, confirmDesignType, getDeviceType } from '@/plugins/userAgent'

interface IData {
  adjustOtherEventLinkPosition: boolean
  dlSetModalStatus: boolean
  cartQueryDeleteModalStatus: boolean
  spotlightDescriptionModalStatus: boolean
  isCartQueryClearComplete: boolean
}

export default Vue.extend({
  components: {
    SectionHeader,
    EventAlbumList,
    EventTitle,
    LeadText,
    RemainingInfo,
    Button,
    LinkButton,
    TextLink,
    UchinokoSelectContainer,
    UnlockPasswordContainer,
    SearchPhotosContainer,
    UchinokoButton,
    CategoryText,
    RecommendEvents,
    Modal,
    DlSetDescription,
    ClearButton,
    SingleIcon
  },
  props: {
    eventId: {
      type: Number,
      required: true
    }
  },
  data(): IData {
    return {
      adjustOtherEventLinkPosition: false,
      dlSetModalStatus: false,
      cartQueryDeleteModalStatus: false,
      spotlightDescriptionModalStatus: false,
      isCartQueryClearComplete: false
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        eventRepository: this.$eventRepository,
        eventId: this.eventId,
        metaRepository: this.$metaRepository,
        groupRepository: this.$groupRepository,
        profileRepository: this.$profileRepository
      })
    },
    hasChildrenListWithThumbnail(): boolean {
      if (this.presenter.childrenList === null) return false
      return this.presenter.childrenList.length >= 1
    },
    hasFacesFromFaceSearch(): boolean {
      return this.presenter.uchinokoFaces.length >= 1
    },
    isFaceSearchAvailable(): boolean {
      // かお検索がOn && 顔検索結果<face情報>が存在する
      return this.presenter.isUchinokoSearchEnabled && this.hasFacesFromFaceSearch
    },
    hasVisibleSearchResult(): boolean {
      return this.presenter.uchinokoPhotosByAlbumsCount >= 1
    },
    isFirstUchinokoAssist(): boolean {
      if (this.presenter.cartQueryStatus && this.presenter.cartQueryStatus.props.hasCartQuery && !this.presenter.cartQueryStatus.props.hasOrderHistory && !this.presenter.isProfileSearchEnabled) {
        return true
      }
      return false
    },
    uchinokoSearchResultText(): string {
      return this.hasVisibleSearchResult ? 'かお検索結果： ' + this.presenter.uchinokoPhotosByAlbumsCount + '枚をみる' : 'かお検索結果： ' + this.presenter.uchinokoPhotosByAlbumsCount + '枚'
    },
    uchinokoPhotosByAlbumsCount(): number {
      return this.presenter.uchinokoPhotosByAlbumsCount
    }
  },
  mounted() {
    // データ送信
    this.putRecordEventDetail()
  },
  methods: {
    changeLinkPosition(bool: boolean) {
      this.adjustOtherEventLinkPosition = bool
    },
    showDlSetDescription(bool: boolean) {
      this.dlSetModalStatus = bool
    },
    showCartQueryDeleteModal(bool: boolean) {
      this.cartQueryDeleteModalStatus = bool
    },
    showSpotlightDescription(bool: boolean) {
      this.spotlightDescriptionModalStatus = bool
    },
    async deleteCartQuery() {
      const deleteCartQueryUseCase = new DeleteCartQueryUseCase({
        snapsnapGateway: this.$snapsnapGateway
      })
      const fetchCartQueryStatusUseCase = new FetchCartQueryStatusUseCase({
        snapsnapGateway: this.$snapsnapGateway,
        eventRepository: this.$eventRepository
      })
      const searchEventCartQueryPhotosUseCase = new SearchEventCartQueryPhotosUseCase({
        snapsnapGateway: this.$snapsnapGateway,
        eventRepository: this.$eventRepository
      })
      try {
        await deleteCartQueryUseCase.execute(this.eventId)
        await Promise.all([fetchCartQueryStatusUseCase.execute({ eventId: this.eventId, isClear: true }), searchEventCartQueryPhotosUseCase.execute({ eventId: this.eventId, isClear: true })])
        this.putRecordFaceDetectClearClick()
        this.isCartQueryClearComplete = true
      } catch (error) {
        console.log(error)
      }
    },
    putRecord(albumListEventType: 'face_search' | 'manual_search') {
      this.putRecordOfAlbumList(albumListEventType)
    },
    putRecordOfAlbumList(eventType: string) {
      // profile情報がnullの場合、returnする
      if (this.presenter.profile === null) return
      // data stream 用のパラメータを設定
      const kinesisData: AlbumListSchema = {
        event_type: eventType,
        event_id: this.eventId,
        member_id: this.presenter.profile.props.id,
        ts: new Date().getTime(),
        design_type: confirmDesignType(),
        device_type: getDeviceType(),
        ...userAgentDedicatedToDataStream
      }

      // put record の実行
      setRecord(kinesisData, this.presenter.profile.props.id)
    },
    putRecordEventDetail() {
      // profile情報がnullの場合、returnする
      if (this.presenter.profile === null) return

      // data stream 用のパラメータを設定
      const kinesisData: EventDetailSchema = {
        event_type: 'event_detail_pv',
        event_id: this.eventId,
        member_id: this.presenter.profile.props.id,
        ts: new Date().getTime(),
        design_type: confirmDesignType(),
        device_type: getDeviceType(),
        ...userAgentDedicatedToDataStream
      }

      // put record の実行
      setRecord(kinesisData, this.presenter.profile.props.id)
    },
    putRecordFaceDetectClearClick() {
      // profile情報がnullの場合、returnする
      if (this.presenter.profile === null) return

      // data stream 用のパラメータを設定
      const kinesisData: FaceDetectClearClickSchema = {
        event_type: 'face_detect_clear_click',
        member_id: this.presenter.profile.props.id,
        ts: new Date().getTime(),
        design_type: confirmDesignType(),
        device_type: getDeviceType(),
        ...userAgentDedicatedToDataStream
      }

      // put record の実行
      setRecord(kinesisData, this.presenter.profile.props.id)
    },
    toFaceSearchSettings() {
      if (this.presenter.adminGroup) {
        this.$router.push({ path: `/families/${this.presenter.adminGroup.props.id}/settings/uchinoko`, query: { eventId: String(this.eventId) } })
      }
    }
  }
})
